export const sliderWidth = 160;
